export const sessionStorageSkippedKey = 'isUserLegalTermsSkipped';
